import React, { useState, useEffect } from 'react';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { toast } from '../../hooks/use-toast';
import { useAuth } from '../../contexts/AuthContext';

interface ApiConfig {
  shopify?: {
    clientId: string;
    clientSecret: string;
  };
}

export const ApiKeys: React.FC = () => {
  const [config, setConfig] = useState<ApiConfig>({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const configRef = doc(db, 'config', 'api_keys');
      const configSnap = await getDoc(configRef);
      if (configSnap.exists()) {
        setConfig(configSnap.data() as ApiConfig);
      }
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
      toast.error('Erro ao carregar configurações');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const configRef = doc(db, 'config', 'api_keys');
      await setDoc(configRef, config, { merge: true });
      toast.success('Configurações guardadas com sucesso');
    } catch (error) {
      console.error('Erro ao guardar configurações:', error);
      toast.error('Erro ao guardar configurações');
    } finally {
      setIsSaving(false);
    }
  };

  // A autorização agora é feita pelo RoleRoute

  if (isLoading) {
    return (
      <div className="p-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Chaves API de Módulos</h1>

      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">Shopify</h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Client ID
            </label>
            <input
              type="text"
              value={config.shopify?.clientId || ''}
              onChange={(e) => setConfig({
                ...config,
                shopify: {
                  ...config.shopify,
                  clientId: e.target.value
                }
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Client Secret
            </label>
            <input
              type="password"
              value={config.shopify?.clientSecret || ''}
              onChange={(e) => setConfig({
                ...config,
                shopify: {
                  ...config.shopify,
                  clientSecret: e.target.value
                }
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <button
          onClick={handleSave}
          disabled={isSaving}
          className="bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSaving ? 'A guardar...' : 'Guardar'}
        </button>
      </div>
    </div>
  );
};
